import React from 'react';
import is from 'is_js';
import { connect } from 'omni-common-ui';
import { accessors as scoreBandAccessors } from 'data/ScoreBand';
import PropTypes from 'prop-types';

const ScoreBand = (props) => {
  if (is.undefined(props.band)) {
    return null;
  }
  const band = props.textKey ? props.band[props.textKey] :
    props.band.interpretation;
  return <p className={props.className}>{band}</p>;
};

ScoreBand.propTypes = {
  className: PropTypes.string,
  band: PropTypes.object,
  textKey: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  const { score } = ownProps;
  const scoreBand = state.get('rootReducer').get('scoreBand');
  const language = state.get('rootReducer').get('language');
  const band = scoreBandAccessors.getBandByScore(score, language, scoreBand);
  return { band };
}

export default connect(mapStateToProps, null)(ScoreBand);



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/StudentReportView/ScoreBand/index.jsx